/**
 * The browser half of the app's own session.
 *
 * The server holds the signing key and decides everything; this module only
 * carries requests. `credentials: 'same-origin'` matters on every call - the
 * cookie is HttpOnly and will not be attached without it.
 */
export interface SessionInfo {
    email: string;
    defaultStore: string;
}

export async function getSession(): Promise<SessionInfo | null> {
    const res = await fetch('/auth/session', {
        credentials: 'same-origin',
        cache: 'no-store',
    });
    return res.ok ? ((await res.json()) as SessionInfo) : null;
}

export async function startSession(idToken: string): Promise<'ok' | 'forbidden' | 'failed'> {
    const res = await fetch('/auth/session', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ idToken }),
    });
    if (res.ok) return 'ok';
    return res.status === 403 ? 'forbidden' : 'failed';
}

export async function saveDefaultStore(storeId: string): Promise<void> {
    await fetch('/auth/session/store', {
        method: 'PUT',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ storeId }),
    });
}

export async function endSession(): Promise<void> {
    await fetch('/auth/session', { method: 'DELETE', credentials: 'same-origin' });
}
